/**
 * @file: 组合函数库
 * @author: xiaolong.huang@dmall.com
 */

import * as Utils from '../../utils/util';
import * as Toolkit from '../../toolkit/index';
import * as CubeTree from '../../cubeTree/index';
import * as FrontCubeData from '../../frontCubeData/index';

/**
 * 创建获取cube尺寸类型字段的组合函数，调用顺序从右向左
 *
 * 1. FrontCubeData.getValue 获取cube前端字段值
 * 2. Utils.toNumber 强制转化为number类型
 * 3. Toolkit.cmToPx 单位换算
 */

const pxSize = Utils.createComposeFunc(Toolkit.cmToPx, Utils.toNumberForce, Utils.toNumber, FrontCubeData.getValue);

export function getPXSizeValue(cubeId: string, key: string): number {
    return pxSize(cubeId, key);
};

export const getCubeNumberValue = Utils.createComposeFunc(Utils.toNumberForce, Utils.toNumber, FrontCubeData.getValue);
